// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elsa-flowchart-diagram-designer-v1 .x6-graph-background {
    background-color: var(--mud-palette-background);
}

.elsa-flowchart-diagram-designer-v1 .x6-widget-selection-box {
    border: 2px dashed var(--mud-palette-secondary);
}

.elsa-flowchart-diagram-designer-v1 .x6-widget-selection-inner {
    border: 1px solid var(--mud-palette-secondary);
}

.elsa-flowchart-diagram-designer-v1 .elsa-snapline .x6-widget-snapline-horizontal,
.elsa-flowchart-diagram-designer-v1 .elsa-snapline .x6-widget-snapline-vertical {
    stroke: var(--mud-palette-secondary);
}

.elsa-flowchart-diagram-designer-v1 .elsa-activity {
    border-left: solid 6px var(--mud-palette-info);
    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
    height: 100%;
}

.elsa-flowchart-diagram-designer-v1 .elsa-activity-wrapper-badge.has-retries .mud-badge-wrapper .mud-badge {
    background-color: #FFEB3B !important;
}`, "",{"version":3,"sources":["webpack://./css/designer.v1.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,yFAAyF;IACzF,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".elsa-flowchart-diagram-designer-v1 .x6-graph-background {\n    background-color: var(--mud-palette-background);\n}\n\n.elsa-flowchart-diagram-designer-v1 .x6-widget-selection-box {\n    border: 2px dashed var(--mud-palette-secondary);\n}\n\n.elsa-flowchart-diagram-designer-v1 .x6-widget-selection-inner {\n    border: 1px solid var(--mud-palette-secondary);\n}\n\n.elsa-flowchart-diagram-designer-v1 .elsa-snapline .x6-widget-snapline-horizontal,\n.elsa-flowchart-diagram-designer-v1 .elsa-snapline .x6-widget-snapline-vertical {\n    stroke: var(--mud-palette-secondary);\n}\n\n.elsa-flowchart-diagram-designer-v1 .elsa-activity {\n    border-left: solid 6px var(--mud-palette-info);\n    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));\n    height: 100%;\n}\n\n.elsa-flowchart-diagram-designer-v1 .elsa-activity-wrapper-badge.has-retries .mud-badge-wrapper .mud-badge {\n    background-color: #FFEB3B !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
